//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The voucher item model.
* 
* @param amount 
* @param combinable The voucher can be combined or not
* @param grantId The voucher grant id
* @param remainingAmount 
* @param voucherCode The voucher code
*/
@Serializable

data class Voucher (


      @SerialName(value = "amount") @Required val amount: Amount,


      /* The voucher can be combined or not */
    @SerialName(value = "combinable") @Required val combinable: kotlin.Boolean,


      /* The voucher grant id */
    @SerialName(value = "grantId") @Required val grantId: kotlin.Int,


      @SerialName(value = "remainingAmount") @Required val remainingAmount: Amount,


      /* The voucher code */
    @SerialName(value = "voucherCode") @Required val voucherCode: kotlin.String


) {




  }

